import type { Address } from "viem";
import { mainnet, arbitrum } from "wagmi/chains";

interface ContractAddressObject {
    [key: string]: Address | ContractAddressObject;
}

const contractAddressesByNetwork: Record<number, ContractAddressObject> = {
    [arbitrum.id]: {
        gateway: "0x46C93715eeba527a466e950d701d7edE526E48f1" as Address,
    },
    [mainnet.id]: {
        gateway: "0x3f04b65Ddbd87f9CE0A2e7Eb24d80e7fb87625b5" as Address,
    },
};

export const getGatewayContractAddress = (chainId: number = mainnet.id): Address => {
    const networkAddresses = contractAddressesByNetwork[chainId];
    if (!networkAddresses) {
        throw new Error(`No contract addresses found for chain ID ${chainId}`);
    }

    return networkAddresses.gateway as Address;
};
